import {
  TOP_NAV_DATA_GA,
  TOP_NAV_DATA_TEST,
} from '@/app/components/layouts/top-navigation/tracking';
import { Link } from '@/app/components/navigation/link';
import type { MenuLinkType } from '@/app/types/top-navigation';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { createDataGA } from '@/app/utils/createDataGA';

interface ItemLinkProps extends MenuLinkType {
  isActiveVehicle?: boolean;
  className?: string;
}

export const Item = ({
  href,
  target,
  label,
  isActiveVehicle,
  className,
  ...rest
}: ItemLinkProps) => {
  const activeVehicleClassName = cn(
    'font-noto-bold relative justify-center',
    'after:absolute after:bottom-0 after:border-6 after:border-t-0 after:border-b-6 after:border-transparent after:border-b-white'
  );

  return (
    <Link
      {...rest}
      href={isActiveVehicle ? '/' : href}
      target={isActiveVehicle ? '_self' : target}
      role="menuitem"
      className={cn(
        'transition-color flex h-full items-center outline-none hover:text-gray-300 focus-visible:text-gray-300',
        {
          [activeVehicleClassName]: isActiveVehicle,
        },
        className
      )}
      {...createDataAttributes({
        test: TOP_NAV_DATA_TEST.navigationMenuLink,
      })}
      {...createDataGA({
        click: true,
        eventName: TOP_NAV_DATA_GA.buyingTools,
        url: isActiveVehicle ? '/' : href,
        text: label,
      })}
    >
      {label}
    </Link>
  );
};
